<ion-icon *ngIf="is_liked" name="icon-heart-outline"></ion-icon>
